import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { SidebarContext } from "../../Context/SidebarContext";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CategoryNav = ({ product }) => {
  const { isSidebarOpen, show } = useContext(SidebarContext);
  return (
    <nav className="flex items-center w-full gap-3 mb-3 h-14 px-2 md:px-0">
      <div className="md:hidden flex items-center justify-center w-full gap-2">
         <h1 className="text-xl font-bold text-[#011936]">
            {product?.category || "Products"}
         </h1>
         <i className="fas fa-angle-right text-xl"></i>
      </div>

      <div className="hidden md:flex items-center gap-3 w-full">
        {!isSidebarOpen && (
          <button onClick={show} className="btn btn-primary">
            <FontAwesomeIcon icon={faFilter} /> Filter
          </button>
        )}
        <NavLink to="/" className="text-gray-500 hover:text-[#2684fe]">Home</NavLink>
        <i className="fas fa-angle-right text-gray-400 text-xs"></i>{" "}
        <NavLink to="/products" className="text-gray-500 hover:text-[#2684fe]">Products</NavLink>
        {product?.category && (
          <>
            <i className="fas fa-angle-right text-gray-400 text-xs"></i>
            <NavLink to={`/products?category=${product?.category}`} className="text-gray-500 hover:text-[#2684fe]">{product?.category}</NavLink>
          </>
        )}
        {product?.sup_category && (
          <>
            <i className="fas fa-angle-right text-gray-400 text-xs"></i>
            <NavLink to={`/products/${product?.sup_category}`} className="text-gray-500 hover:text-[#2684fe]">
              {product?.sup_category}
            </NavLink>
          </>
        )}
        {product?.name && (
          <>
            <i className="fas fa-angle-right text-gray-400 text-xs"></i>
            <p className="text-gray-400">{product?.name}</p>
          </>
        )}
      </div>
    </nav>
  );
};

export default CategoryNav;
